import React, { useState } from 'react';
import {
  AppBar,
  Button,
  Toolbar,
  Box,
  Hidden,
  IconButton,
  SwipeableDrawer,
  Divider,
  Container,
  Link,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { Link as ScrollLink, scroller } from 'react-scroll';
import {
  ExpandLess,
  Brightness4,
  Brightness7,
  Menu,
} from '@mui/icons-material';
import ElevationScroll from './ElevationScroll';
import ToggleDarkMode from './ToggleDarkBtn';

import lightLogo from '../Assets/Images/CKlight.png';
import darkLogo from '../Assets/Images/CKdark.png';
import NavLinks from '../Data/NavLinks.json';
import Data from '../Data/PersonalInfo.json';

const Navbar = ({ mode, setMode, props }) => {
  // Use theme
  const theme = useTheme();

  // Hamburger menu open/close Hook
  const [menuOpen, setMenuOpen] = useState(false);

  // For determining active link
  const [activeSection, setActiveSection] = useState('');

  // handling active link
  const handleSetActive = (to) => {
    setActiveSection(to);
  };

  // Theme toggle
  const toggleMode = () => {
    setMode(mode === 'light' ? 'dark' : 'light');

    // React Scroll configuration for sm screens
    scroller.scrollTo('sectionName', {
      smooth: true,
      offset: -70,
      duration: 500,
    });
  };

  // handle hamburger menu open/close
  const handleMenuOpen = () => {
    setMenuOpen(true);
  };
  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  // Render NavLinks  and react scroll configuration
  const renderNavLinks = () =>
    NavLinks.map((item) => (
      <ScrollLink
        to={item.to}
        spy={true}
        smooth={true}
        offset={-50}
        duration={500}
        key={item.name}
        activeClass='active'
        onSetActive={handleSetActive}
      >
        <Button
          variant='inherit'
          sx={{
            fontFamily: 'Neue Montreal Bold',
            borderBottom:
              activeSection === item.to
                ? mode === 'light'
                  ? `2px solid ${theme.palette.common.black}`
                  : `2px solid ${theme.palette.common.white}`
                : 'none',
            borderRadius: '0px',
          }}
        >
          {item.name}
        </Button>
      </ScrollLink>
    ));

  // Resume Link
  const renderResume = () => (
    <Button
      variant='inherit'
      component={Link}
      href={Data.resume}
      target='_blank'
      rel='noopener noreferrer'
      sx={{
        fontFamily: 'Neue Montreal Bold',
      }}
    >
      Resume
    </Button>
  );

  return (
    <ElevationScroll>
      <AppBar
        position='sticky'
        color='transparent'
        sx={{ backdropFilter: 'blur(7px)' }}
        elevation={0}
        height='70px'
      >
        <Container maxWidth='xxl'>
          <Toolbar sx={{ width: '100%', height: '70px' }}>
            {/* --- Orienting Appbar Links  --- */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                height: '70px',
              }}
            >
              {/* ----- Logo Box ---- */}
              <Box>
                <img
                  src={mode === 'dark' ? darkLogo : lightLogo}
                  alt='logo'
                  height='30'
                  width='30'
                />
              </Box>

              {/* ------ NavLink  (screen above `sm`) ----- */}
              <Box>
                <Hidden smDown>
                  {renderNavLinks()}
                  {/* --- Resume -----*/}
                  {renderResume()}
                  {/* ---- Toggle Theme ---- */}
                  <IconButton aria-label='Toggle theme' onClick={toggleMode}>
                    <ToggleDarkMode />
                  </IconButton>
                </Hidden>

                {/* ----- Hamburger Menu ---- */}
                <Hidden smUp>
                  <IconButton aria-label='Menu' onClick={handleMenuOpen}>
                    <Menu
                      sx={{ color: mode === 'light' ? 'black' : 'white' }}
                    />
                  </IconButton>
                </Hidden>
              </Box>
            </Box>
          </Toolbar>

          {/* ----- Swippable Drawer (for mob screens) ---- */}
          <Hidden smUp>
            <SwipeableDrawer
              anchor='top'
              open={menuOpen}
              onOpen={handleMenuOpen}
              onClose={handleMenuClose}
            >
              <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                sx={{ m: 1 }}
              >
                {/* --- NavLinks ---- */}
                {renderNavLinks()}
              </Box>
              {/* ---Resume --- */}
              {renderResume()}
              <Button
                variant='inherit'
                sx={{
                  fontFamily: 'Neue Montreal Bold',
                }}
                startIcon={mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
                onClick={toggleMode}
              >
                {mode === 'light' ? 'dark' : 'light'} MODE
              </Button>
              <Divider />
              <IconButton
                onClick={handleMenuClose}
                sx={{ '&:hover': { borderRadius: '3px' } }}
              >
                <ExpandLess />
              </IconButton>
            </SwipeableDrawer>
          </Hidden>
        </Container>
      </AppBar>
    </ElevationScroll>
  );
};

export default Navbar;
